import { Box } from "@mui/material";
import React, { ReactNode } from "react";

interface DashboardContainerProps {
  children: ReactNode;
}

export const DashboardContainer = ({ children }: DashboardContainerProps) => (
    <Box
        sx={{
            marginTop: "128px",
            height: "calc(100% - 128px)",
            overflowY: "hidden",
            overflowX: "hidden",
            paddingTop: "8px",
        }}
    >
        {children}
    </Box>
);
